import {Component, model, OnInit, signal, viewChild} from '@angular/core'
import {NgModel} from '@angular/forms'
import {DateTime} from 'luxon'

export type TModel = string | number | DateTime | [DateTime, DateTime] | null

@Component({
  template: ''
})
export class BaseComponent implements OnInit {
  // This model is used by your form
  public model = model.required<TModel>()
  public valid = signal<boolean>(false)

  public debugName = 'base'

  /**
   * Exactly one control in this template. The subclass
   * must implement exactly one (1) item with id=input.
   * The input should be assigned the model.
   */
  public control = viewChild<NgModel>('input')

  public ngOnInit() {
    this.control()?.valueChanges?.pipe()
      .subscribe(() => {
        this.valid.set(!this.control()!.control.errors)
      })
  }
}
